import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  useCallback,
  type ReactNode,
} from 'react';

type PageHeaderContextValue = {
  headerTitleOverride: string | null;
  setHeaderTitleOverride: (title: string | null) => void;
};

const PageHeaderContext = createContext<PageHeaderContextValue | null>(null);

export function PageHeaderProvider({ children }: { children: ReactNode }) {
  const [headerTitleOverride, setHeaderTitleOverrideState] = useState<string | null>(null);

  const setHeaderTitleOverride = useCallback((title: string | null) => {
    setHeaderTitleOverrideState(title);
  }, []);

  const value = useMemo(
    () => ({ headerTitleOverride, setHeaderTitleOverride }),
    [headerTitleOverride, setHeaderTitleOverride]
  );

  return (
    <PageHeaderContext.Provider value={value}>{children}</PageHeaderContext.Provider>
  );
}

export function usePageHeader(): PageHeaderContextValue {
  const ctx = useContext(PageHeaderContext);
  if (!ctx) {
    throw new Error('usePageHeader must be used within PageHeaderProvider');
  }
  return ctx;
}
